import { changeCarsImages } from './utils/functions.js';
import { initFavorites } from './utils/functions.js';
import { initCarListModals } from './utils/functions.js';


document.addEventListener('DOMContentLoaded', () => {
let currentFilters = {};
let currentSort = {
  type: null,
  direction: null
};


const filterSort = document.querySelector('.sorting');
function clearSort() {
    
      currentSort = {
  type: null,
  direction: null
};
         const els = filterSort.querySelectorAll('.item');
          els.forEach((ctx) => {
               els.forEach(el => el.classList.remove('active'));
  
  }); 
    
}

   const els = filterSort.querySelectorAll('.item');
  els.forEach((ctx) => {
    ctx.addEventListener('click', debounce(() => {
                const form = document.querySelector('.common-sort');
        const formData  = new FormData(form);
       const filters = Object.fromEntries(formData.entries());
 currentFilters = filters;



      els.forEach(el => el.classList.remove('active'));
      
      const type = ctx.getAttribute('data-type');
      const sort = ctx.getAttribute('data-sort');
      
      ctx.classList.add('active');
      currentSort = { type, direction: sort };
      
      // Инверсия для следующего клика
      ctx.setAttribute('data-sort', sort === 'asc' ? 'desc' : 'asc');
    
   
      
      debouncedLoadCars(1);
    }, 300));
  });

  document.addEventListener('click', (e) => {
    if (e.target.closest('.page-link')) {
        e.preventDefault();
        const page = e.target.closest('.page-link').dataset.page;
        debouncedLoadCars(page);
        scrollToTopCarList();
    }
});


function scrollToTopCarList() {
// document.querySelector('#results').scrollIntoView({
//   behavior: 'smooth',
//   block: 'start' // 'start', 'center', 'end', 'nearest'
// });
const element = document.querySelector('.results');
const offset = element.offsetTop - 50;
window.scrollTo({
  top: offset,
  behavior: 'smooth'
});
}


const debouncedLoadCars = debounce(loadCars, 300);
async function loadCars(page = 1) {
    const loader = document.querySelector('.loader-icon');
    const pagination = document.querySelector('.pagination-container');
    const carsContainer = document.getElementById('filter-cars');
    if (loader) loader.style.display = 'flex';
  

    try {
        // 1. Создаем объект с данными запроса
        const requestData = {
            ...currentFilters,
            page: page,
          
        };



          // 2. Добавляем параметры сортировки, если они есть
        if (currentSort && currentSort.type) {
            requestData.sort = {
                type: currentSort.type,
                direction: currentSort.direction
            };
        }
        
        // 3. Отправляем запрос
        const response = await fetch('/api/cars/filter', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestData) // Используем requestData здесь
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        
        if (data.total == 0) {
        carsContainer.innerHTML =   `
                <div class="alert alert-info">
                  По заданным параметрам ничего не найдено
                </div>
            `;
            pagination.innerHTML = '';
            return;
        }
      
 carsContainer.innerHTML = data.html;
  pagination.innerHTML = data.pagination_html;
// carsContainer.insertAdjacentHTML('afterbegin', 
//   `<div class="cars-counter">Найдено ${data.total} авто</div>`
// );
changeCarsImages();
initFavorites();
initCarListModals();
clearStaticCars();

    } catch (error) {
        console.error('Error loading cars:', error);
        // Можно добавить отображение ошибки пользователю
    } finally {
        if (loader) loader.style.display = 'none';

    }
}

function clearStaticCars() {
    const container = document.querySelector('.all-cars');
    if (container) {
       container.remove();
    }
   
}
  function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { func.apply(this, args); }, timeout);
    };
  }




});